import { Injectable } from '@angular/core';

@Injectable()
export class WhenScrolledService {
    private ignoreScrollEvent: boolean = false;
    constructor() {}

    isScrollEventIgnored() {
        return this.ignoreScrollEvent;
    }

    withIgnoringScrollEvent(callback: (resolve: () => void) => void, finishTimeout: number = 1) {
        this.ignoreScrollEvent = true;
        const promise = new Promise<void>((resolve, reject) => {
            callback(resolve);
        });
        promise.then(() => {
            setTimeout(() => {
                this.ignoreScrollEvent = false;
            }, finishTimeout);
        });
    }
}
